import React from 'react';

import {useStore} from 'effector-react';

import {useTranslation} from 'react-i18next';

import {I18N_NS} from '../../core/constants/names';
import {$allowedActionsForInvoice, $doesInvoiceExist} from '../../models/common';
import {arrStores, $invoiceCreationPage, invoiceCreationPage} from '../../models/create';
import {$invoiceCreatingPending} from '../../models/details';

import {setXmlFile} from '../helpers/buildXml';

import {FlexContainer, ButtonsContainer, Button} from './styled';

export const STEPS_LENGTH = 4;

export const ControlSection = ({
    onSubmit,
    nextIndex,
    nextIsDisabled = false,
}: {
    onSubmit: any;
    nextIndex?: number;
    nextIsDisabled?: boolean;
}) => {
    const {t} = useTranslation(I18N_NS);
    // const invoiceIsRemoved = useStore($invoiceIsRemoved);
    // const newInvoiceIsDone = useStore($newInvoiceIsDone);
    // const history = useHistory();
    const doesInvoiceExist = useStore($doesInvoiceExist);
    const invoiceCreatingPending = useStore($invoiceCreatingPending);
    const currentPageIndex = useStore($invoiceCreationPage);
    const allowedActionsForInvoice = useStore($allowedActionsForInvoice);
    const GEN_INFO = 'pages.documents.invoices.create';

    const generalDataFromStore = useStore(arrStores);

    // useEffect(() => {
    //     console.log(newInvoiceIsDone);
    //     if (newInvoiceIsDone || invoiceIsRemoved) {
    //         history.goBack();
    //     }
    // }, [newInvoiceIsDone, invoiceIsRemoved]);

    function turnPageNext() {
        if (nextIndex) {
            onSubmit(nextIndex);
        } else {
            onSubmit();
        }
    }
    function turnPagePrev() {
        invoiceCreationPage(currentPageIndex - 1);
    }

    function showXml() {
        setXmlFile(generalDataFromStore);
    }

    function sendForCreatingInvoice() {
        onSubmit();
    }

    return (
        <ButtonsContainer>
            <div />
            <FlexContainer>
                {currentPageIndex ? (
                    <Button typeView="back" type="button" onClick={turnPagePrev}>
                        {t(`${GEN_INFO}.buttons.back`)}
                    </Button>
                ) : (
                    <></>
                )}
                {currentPageIndex >= STEPS_LENGTH - 1 ? (
                    allowedActionsForInvoice.edit ? (
                        <Button
                            disabled={invoiceCreatingPending}
                            onClick={sendForCreatingInvoice}
                            typeView="next"
                            type="button"
                        >
                            {t(`${GEN_INFO}.buttons.approve`)}
                        </Button>
                    ) : (
                        <></>
                    )
                ) : (
                    <Button
                        disabled={nextIsDisabled}
                        typeView="next"
                        type="button"
                        onClick={turnPageNext}
                    >
                        {t(`${GEN_INFO}.buttons.next`)}
                    </Button>
                )}
            </FlexContainer>
        </ButtonsContainer>
    );
};
